module.exports = __webpack_public_path__ + "media/images/weather/150_day-2929d4f6c92fb83752989846d5dfc153.png";